export default {
  getFavoriteVendors(state) {
    return state.favoriteVendors;
  },
  getFavoriteProducts(state) {
    return state.favoriteProducts;
  },

};